<template>
  <div id="roomListinPackage" >
    <h3 v-if="isOpera">{{ strings.roomDetails }}</h3>
    <h3 v-else>{{ strings.choosearoom }}</h3>
    <p v-if="selectedLang !== 'de' && !isOpera" class="small">{{ strings.showing }} <strong>{{ availableRoom }} {{ strings.outof }} {{numRoom}}</strong> {{ strings.rooms }} {{ strings.suitablecriteria }}.</p>
    <!-- Customized radio buttons -->
    <form class="radio">

        <MPRoomItem 
        :id="item.id" 
        v-for="(item, key) in roomList" 
        :key="key"
        v-show="key < x"
        :title="item.title"
        :instantBookable="item.instant_bookable"
        :roomMin="item.min"
        :roomMax="item.max"
        :roomDescription="item.description == null ? '' : item.description.value"
        :roomLayout="item.room_layout"
        :roomLayoutOriginal="item.room_layout_original"
        :roomHeight="item.height"
        :roomWidth="item.width"
        :roomLength="item.length"
        :roomArea="item.area"
        :roomEquipment="item.equipment_name"
        :roomEquipmentFee="item.equipment_fee_name"
        :packages="item.packages"
        :available="item.is_smart_space == true ? true: item.available"
        :isSmartSpace="item.is_smart_space == true"
        :minRevenue="item.min_revenue ? item.min_revenue: 0"
        :roomPriceVat="item.room_price_vat"       
        :demand="item.demand ? item.demand: ''"
        :exceed="item.is_smart_space == true ? 'no': item.exceed"
        :valid_layout="item.is_smart_space == true ? true: item.valid_layout"
        :no_layout="item.no_layout"
        :image="item.room_pictures"
        :day="day"
         />
    </form>
    <div v-if="availableRoom == 0 && isBE && selectedPackage.is_smart_space ? selectedPackage.is_smart_space != true : false" class="temp mb-15 radio__no-avail">
        <label for="radio6">
            <div class="radio__main">
                <div class="">
                    <h3>There is no rooms available with your current criteria.</h3>
                </div>
            </div>
        </label>
    </div>

    <a href="" class="button full-on-mobile" @click.prevent="showMore()" v-if="showMoreStatus">{{ strings.showmore }} {{ strings.rooms }} ({{roomLeft}})</a>
    <a href="" v-scroll-to="'#roomListinPackage'" class="button full-on-mobile" @click.prevent="showLess()" v-if="showFewerStatus && selectedLang == 'de'">Weniger Tagungsräumen anzeigen</a>
    <a href="" v-scroll-to="'#roomListinPackage'" class="button full-on-mobile" @click.prevent="showLess()" v-if="showFewerStatus && selectedLang != 'de'">{{ strings.showfewer }} {{ strings.rooms }}</a>
    
  </div>
</template>

<script>
import MPRoomItem from './RoomItem';
export default {
    watch: {
        selectedRoomIndex(newValue) {
            let roomLength = this.$store.state.rooms_in_package.length;
            let selectedRoom = this.$store.state.selectedRoominPackage;
            if(newValue >= 5){
                this.x = roomLength;
            }
            setTimeout(() => {
                this.$scrollTo('.room_' + selectedRoom);
            }, 50);
        }
    },
    data () {
        return {
            x: 5,
            step: 5,
            roomLeft: ''
        }
    },
    props: [
        'selected_room_in_package',
        'packages',
        'room_list_in_package',
        'day'
            ],
    components: {
        MPRoomItem
    },
    computed: {
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        isMoreThanOneDay() {
            return this.$store.state.isMoreThanOneDay;
        },
        selectedPackage(){
            let selectedPackageId = this.$store.state.selectedPackage;
            if (this.$store.state.packageInfo) {
                let filteredPackages = this.$store.state.packageInfo.filter(function(e){
                    return e.id == selectedPackageId;
                });
                return filteredPackages[0];
            } else {
                return {}
            }
        },
        // If current tab is package, show room list in the chosen package. If not show all rooms.
        roomList() {
            if(this.isMoreThanOneDay){
                return this.room_list_in_package;
            } else {
                return this.$store.state.rooms_in_package;
            }
        },
        showMoreStatus() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.rooms_in_package.length;
            }

            this.roomLeft = roomLength - this.x;
            if(this.x >= roomLength){
                return false;
            } else {
                return true;
            }
        },
        showFewerStatus() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.roomInfo.length;
            }
            if(this.x == roomLength && roomLength != 5){
                return true;
            } else {
                return false;
            }
        },
        numRoom() {
            return this.$store.state.rooms_in_package.length;
        },
        availableRoom() {
            let roomList = this.isMoreThanOneDay ? this.room_list_in_package : this.$store.state.rooms_in_package;
            let count = 0;
            if(roomList){
                roomList.forEach(element => {
                    if(element.available && element.exceed == 'no' && element.valid_layout){
                        count++;
                    }
                });
            }
            return count;
        },
        strings () {
	        return this.$store.state.strings
        },
        selectedRoomIndex() {
            return this.$store.state.selectedRoomIndexinPackage;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        isBE() {
            return this.$store.state.isBE;
        }
    },
    methods: {
        showMore() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.rooms_in_package.length;
            }
            this.x = this.x + this.step <= roomLength ? this.x + this.step : roomLength;
            this.roomLeft = roomLength - this.x;
        },
        showLess() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.rooms_in_package.length;
            }
            this.x = 5;
            this.roomLeft = roomLength - this.x;
        }
    }
}
</script>

<style>

</style>
